<div class="jd-container">
  <mat-card class="jd-card">
    <div class="jd-card-content">
      <mat-icon class="jd-icon success">check_circle</mat-icon>
      <h2>Account Connected</h2>
      <p class="jd-description">
        Your John Deere Operational Center account has been successfully connected. Your field operation data will now be automatically synced to Precision Gateway.
      </p>

      <button mat-raised-button color="primary" class="jd-button" routerLink="/mapping">
        <mat-icon>map</mat-icon>
        <span>Back to Map</span>
      </button>
    </div>
  </mat-card>
</div>
